import { motion } from "framer-motion";
import { useState } from "react";

interface AnimatedToggleProps {
  state: boolean;
  handleClick: () => void;
  title?: string;
}

const AnimatedToggle: React.FC<AnimatedToggleProps> = ({
  state,
  handleClick,
  title = "Toggle this option"
}) => {
  // States definition
  const [blockClick, setBlockClick] = useState(false);

  /**
   * Function that wraps the click in order to prevent 
   * clicking when the animation hasn't finished 
   * @returns 
   */
  const onClickWrapper = () => {
    // Check if the button click is blocked
    if (blockClick) return;

    // Block the click
    setBlockClick(true);

    // And execute the handle click
    handleClick();
  }

  /**
   * Funciton that releases the button in order to be
   * clicked again
   */
  const unblockClick = () => {
    setBlockClick(false);
  }

  return (
    <div className="self-stretch inline-flex flex-col justify-center items-center gap-2">
      <div
        role="button"
        onClick={onClickWrapper}
        className="w-9 h-5 relative cursor-pointer"
        title={title}
      >
        {/* Track */}
        <motion.div
          className={`w-9 h-4 left-0 top-[2px] absolute ${
            state ? "bg-accent-200" : "bg-neutral-400"
          } rounded-xl`}
        />

        {/* Knob */}
        <motion.div
          className={`w-5 h-5 absolute ${
            state ? "bg-accent-500" : "bg-neutral-200"
          } rounded-full shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)]`}
          initial={{ left: state ? 15 : 0 }}
          animate={{
            left: state ? 15 : 0,
          }}
          transition={{
            duration: 0.2,
            ease: "easeOut",
          }}
          onAnimationComplete={unblockClick}
        />
      </div>
    </div>
  );
};

export default AnimatedToggle;
